import { PRODUCT_SUCCESS } from '../actions';

const INIT_STATE = {
  product: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case PRODUCT_SUCCESS:
      return {
        ...state,
        product: action.payload,
      };
    default:
      return { ...state };
  }
};
